const getDefaultState = () => {
  return {
    leadPid: null,
    patient: {},
    invoice: {},
    treatments: [],
    transactions: [],
    activeMedications: []
  }
}
const state = getDefaultState()

export default {
  namespaced: true,
  state,
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    setLeadPid (state, data) {
      state.leadPid = data
    },
    setPatient (state, data) {
      state.patient = data
    },
    setInvoice (state, data) {
      state.invoice = data
      state.treatments = data.products || []
    },
    setTreatments (state, data) {
      state.treatments = data
    },
    setTransactions (state, data) {
      state.transactions = data
    },
    setActiveMedications (state, data) {
      state.activeMedications = data
    }
  },
  getters: {
    getLeadPid (state) {
      return state.leadPid
    },
    getPatient (state) {
      return state.patient
    },
    getInvoice (state) {
      return state.invoice
    },
    getTreatments (state) {
      return state.treatments
    },
    getTransactions (state) {
      return state.transactions
    },
    getActiveMedications (state) {
      return state.activeMedications
    }
  }
}
